import { observer } from 'mobx-react-lite'
import { ConfirmBtn } from '../cartItemDeleteButton'
import * as PropTypes from 'prop-types'
import React, { useEffect, useRef, useState } from 'react'
import { Switch } from '@headlessui/react'
import { formatPrice } from '../../../utils/format-price'
import { NewsletterController } from '../../../datastores/newsletterController'
import clx from 'classnames'
import { EventGroup } from '../../../datastores/eventGroup'
import * as _ from 'lodash/fp'
import { ValidateAddParticipantController } from '../../../datastores/validateAddParticipantController'
import { ValidateNewsletterController } from '../../../datastores/validateNewsletterController'
import { ObservableMap } from 'mobx'
import { Participant } from '../../../datastores/participant'
import { ViewModel } from 'mobx-utils'
import { LabeledInputField } from '../../inputs/LabeledInputField'
import { ValidateType } from '../../../datastores/validateType'
import Translator from '../../translator'
import { RootStore } from '../../../datastores/rootStore'

const toTitleCase = _.pipe(
  _.split(' '),
  _.map(_.capitalize),
  _.join(' '),
  _.split('-'),
  _.map(_.upperFirst),
  _.join('-')
)

export function ToggleButton({ children, ...props }) {
  return (
    <Switch
      checked={props.checked}
      onChange={props.onChange}
      className={clx('mtt-newsletter-button', {
        'mtt-newsletter-button--active': props.checked
      })}
    >
      {children}
    </Switch>
  )
}

ToggleButton.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  children: PropTypes.node
}
/** @type import('React').FC<any>*/
export const Button = function Button({ children, ...props }) {
  return <button {...props}>{children}</button>
}
Button.propTypes = {
  children: PropTypes.node
}
export const ParticipantView = observer(function ParticipantView(props) {
  let hasMailDiscountAvailable = props.eventGroups.some(eventGroup =>
    Boolean(eventGroup.discountsAvailable.maillist)
  )
  let validateAddParticipantController =
    ValidateAddParticipantController.getInstance()
  const [validateNewsletterController] = useState(
    new ValidateNewsletterController()
  )
  const [start, setStart] = useState()
  const [end, setEnd] = useState()
  const ref = useRef()

  useEffect(() => {
    ref.current.setSelectionRange(start, end)
  }, [start, end])
  return (
    <div className='participants-modal-person'>
      <div className='participants-modal-person__header'>
        <span className='participants-modal-person__title'>
          {Translator.translateReplace(
            'Deltager %s',
            [props.index + 1],
            'participant'
          )}
        </span>
        <span className='participants-modal-person__price'>
          {formatPrice(
            props.p.personalPrice
              ? props.p.personalPrice
              : props.eventGroups.reduce(
                  (acc, eventGroup) => acc + props.p.getPriceFor(eventGroup),
                  0
                )
          )}
        </span>
        <ConfirmBtn
          string={Translator.translate('Slet deltager?', 'participant')}
          onConfirmed={() => {
            props.onDelete()
          }}
        />
      </div>
      <div className='form'>
        <LabeledInputField
          labelText={Translator.translate('Navn', 'participant')}
          required={true}
          id='participant_name'
          type='text'
          forwardedRef={ref}
          value={props.p.name ?? ''}
          errorMessage={validateAddParticipantController.getErrorMessageForField(
            'name',
            props.p.id
          )}
          onChange={e => {
            let target = e.target
            props.p.name = toTitleCase(target.value)
            setStart(target.selectionStart)
            setEnd(target.selectionEnd)
            validateAddParticipantController.validateParticipantFields(
              props.eventGroups,
              [props.p]
            )
          }}
          onBlur={e => {
            validateAddParticipantController.validateParticipantFields(
                props.eventGroups,
                [props.p]
            )
          }}
        />
        <LabeledInputField
          labelText={Translator.translate('Stilling', 'participant')}
          required={true}
          id='participant_position'
          type='text'
          value={props.p.position ?? ''}
          errorMessage={validateAddParticipantController.getErrorMessageForField(
            'position',
            props.p.id
          )}
          onChange={e => {
            props.p.position = e.target.value
            validateAddParticipantController.validateParticipantFields(
              props.eventGroups,
              [props.p]
            )
          }}
          onBlur={e => {
            validateAddParticipantController.validateParticipantFields(
                props.eventGroups,
                [props.p]
            )
          }}
        />
        <LabeledInputField
          labelText={Translator.translate('Email', 'participant')}
          required={true}
          id='participant_email'
          type='text'
          value={props.p.email ?? ''}
          errorMessage={validateAddParticipantController.getErrorMessageForField(
            'email',
            props.p.id
          )}
          onChange={async e => {
            props.p.email = e.target.value

            validateAddParticipantController.validateParticipantFields(
                props.eventGroups,
                [props.p]
            )

            if (
              hasMailDiscountAvailable &&
              ValidateType.validateEmail(e.target.value) === true
            ) {
              try {
                await validateNewsletterController.validate(
                  props.eventGroups,
                  [props.p],
                  RootStore.getInstance().cart.customer,
                  RootStore.getInstance().cart.coupon
                )
                if (validateNewsletterController.isAllValid) {
                  let validation_data = validateNewsletterController.validation
                  let es = {}
                  for (const [, eg] of Object.entries(validation_data)) {
                    for (const [pid, p] of Object.entries(eg)) {
                      es[pid] ??= es[pid] || { price: 0, discounts: {}, vat: 0 }
                      es[pid].price += p.data.price
                      es[pid].vat += p.data.vat
                      es[pid].newsletter = p.data.newsletter ?? false
                      for (const [did, d] of Object.entries(p.data.discounts)) {
                        es[pid].discounts[did] = d
                      }
                    }
                  }
                  props.p.discounts = new ObservableMap(
                    Object.entries(es[props.p.id].discounts)
                  )
                  props.p.newsletter = es[props.p.id].newsletter
                  props.p.price = es[props.p.id].price
                  props.p.vat = es[props.p.id].vat
                }
              } catch (e) {
                if (e.code === 20) {
                  // fetch was aborted, do nothing
                } else {
                  throw e
                }
              }
            }
          }}
          onBlur={e => {
            validateAddParticipantController.validateParticipantFields(
                props.eventGroups,
                [props.p]
            )
          }}
        />
        {hasMailDiscountAvailable ? (
          <Button
            className={clx('mtt-newsletter-button', {
              'mtt-newsletter-button--active': props.p.hasNewsletterDiscount,
              loading: validateNewsletterController.isLoading
            })}
            onClick={async () => {
              await NewsletterController.getInstance().show(props.p)
              await props.p.checkNewsletterStatus(props.eventGroups[0].id)
            }}
          >
            {props.p.hasNewsletterDiscount
              ? Translator.translate('Du er på nyhedsbrevet og får rabat', 'participant')
              : Translator.translate('Tilmeld dig nyhedsbrevet og få rabat', 'participant')}
          </Button>
        ) : null}
        {_.pipe(
          () =>
            validateAddParticipantController.errors?.participantErrors?.[
              props.p.id
            ] ?? {},
          _.omit('field_position_too_long'),
          Object.entries,
          _.map(([key, error]) => (
            <div key={key} className='mtt-input-field__error'>
              {error}
            </div>
          ))
        )()}
      </div>
    </div>
  )
})
ParticipantView.propTypes = {
  p: PropTypes.oneOfType([
    PropTypes.instanceOf(Participant),
    PropTypes.instanceOf(ViewModel)
  ]),
  eventGroups: PropTypes.arrayOf(PropTypes.instanceOf(EventGroup)).isRequired
}
